module.exports = __webpack_public_path__ + "static/media/artist-music.47ed1b0e.jpeg";